import ImapIcon from 'assets/chat/IMail.svg';
import InstagramIcon from 'assets/chat/badgeIcon/Instagram.svg';
import MessangerIcon from 'assets/chat/badgeIcon/Messanger.svg';
import WhatsAppIcon from 'assets/chat/badgeIcon/WhatsApp.svg';

export const PLATFORM_CONFIG = {
  whatsapp: {
    icon: WhatsAppIcon,
    name: 'WhatsApp',
    badgeClass: '',
    platformClass: 'whatsapp',
  },
  instagram: {
    icon: InstagramIcon,
    name: 'Instagram',
    badgeClass: 'instaIcon',
    platformClass: 'instagram',
  },
  facebook: {
    icon: MessangerIcon,
    name: 'Messenger',
    badgeClass: 'fbIcon',
    platformClass: 'facebook',
  },
  imap: {
    icon: ImapIcon,
    name: 'Email',
    badgeClass: 'ImapIcon',
    platformClass: 'imap',
    bg: '#0277FF',
  },
};

/**
 * Formats unread count for display
 * Shows "99+" if count is greater than 99
 * @param {number} count - The unread count
 * @returns {string|number} Formatted count
 */
export const formatUnreadCount = (count) => {
  if (count > 99) return '99+';
  return count;
};

/**
 * Formats unread count for chat list items
 * Shows "9+" if count is greater than 9
 * @param {number} count - The unread count
 * @returns {string|number} Formatted count
 */
export const formatChatListUnreadCount = (count) => {
  if (count > 9) return '9+';
  return count;
};
